<template>
    <div
        id="noticeContainer"
        class="container-fluid">
        <ul
            class="nav nav-tabs"
            id="myTab"
            role="tablist"
            v-if="tabs.length > 1">
            <li
                v-for="tab in tabs"
                class="nav-item"
                role="presentation"
                :key="tab.id">
                <button
                    class="nav-link"
                    :class="{active: tab.id == selectedTab}"
                    data-bs-toggle="tab"
                    :data-bs-target="`#${tab.id}`"
                    type="button"
                    role="tab"
                    @click.prevent="selectedTab = tab.id"
                    :aria-controls="tab.id"
                    aria-selected="true">
                    {{ tab.name }}
                </button>
            </li>
        </ul>
        <h4 v-else-if="tabs.length === 1">{{ tabs[0].name }}</h4>
        <div
            class="alert alert-danger"
            v-else>
            Insufficient Access!
        </div>
        <div class="tab-content border-start border-end border-bottom">
            <div
                class="tab-pane fade"
                :class="selectedTab == 'scheduled' ? 'show active' : ''"
                id="scheduled"
                role="tabpanel"
                aria-labelledby="scheduled-tab"
                tabindex="0"
                v-if="hasPermission('GenerateNotices')">
                <create-edit-notice
                    :title="updateModalTitle"
                    :show-modal="createEditModal"
                    :item="selectedRow"
                    @dismiss="handleUpdateModalDismiss"></create-edit-notice>
                <div class="d-flex flex-row-reverse pe-3">
                    <button
                        id="btnCreateNotice"
                        class="btn btn-blue pull-right mt-2"
                        @click.prevent="handleCreateNoticeClick()">
                        Create Notice
                    </button>
                </div>
                <scheduled-notices   @edit-click="handleEditClick($event)"></scheduled-notices>
            </div>
            <div
                class="tab-pane fade"
                :class="selectedTab == 'notices' ? 'show active' : ''"
                id="notices"
                role="tabpanel"
                aria-labelledby="notices-tab"
                tabindex="0">
                <all-notices></all-notices>
            </div>
        </div>

        <system-alerts></system-alerts>
    </div>
</template>
<script setup lang="ts">
import {computed, ref, onMounted} from "vue";
import ScheduledNotices from "./Notices/ScheduledNotices.vue";
import AllNotices from "./Notices/AllNotices.vue";
import CreateEditNotice from "./Notices/CreateEditNotice.vue";
import {ScheduledItem, NoticeModel, NotificationSchedule} from "./Notices/types";
import {InformationModal, SystemAlerts} from "./Misc";
import hasPermission from "@/composable/permissionHelper";
import {Tab} from "@/types";

const tabs = computed(() => {
    let tabs = [] as Tab[];

    if (hasPermission("GenerateNotices")) {
        tabs.push({name: "Scheduled Notices", id: "scheduled"});
    }
    if (hasPermission("NoticesMainPage")) {
        tabs.push({name: "All Notices", id: "notices"});
    }

    return tabs;
});

const selectedTab = ref(tabs.value.length > 0 ? tabs.value[0].id : "");
var createEditModal = ref(false);
var selectedRow = ref({} as ScheduledItem);

var updateModalTitle = ref("");



function handleUpdateModalDismiss() {
    createEditModal.value = false;
}

function handleCreateNoticeClick() {
    selectedRow.value = {} as ScheduledItem;
    updateModalTitle.value = "Create Notice";
    createEditModal.value = true;
}

function handleEditClick(item: ScheduledItem) {
    selectedRow.value = item;
    updateModalTitle.value = "Edit Notice";
    createEditModal.value = true;
}
</script>
